import React, { useEffect, useState, useRef, useMemo } from 'react';
import XLSX from 'xlsx';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  Button,
  useTheme,
  FormControl,
  FormHelperText,
  Fab,
  IconButton,
} from '@material-ui/core';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { Table } from 'antd';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { useLocation, history } from 'umi';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import dayjs from 'dayjs';
import { fmtThousand } from '@/utils/comUtil';
import { download } from '@/utils/downloadUtil';
import DateRangePickerML from '@/components/DateRangePickerML';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ModalML from '@/components/ModalML/NewModalML';
import ImagePreviewDialog from '@/components/ImagePreviewDialog';
import CouponModal from './components/operate_modal/coupon_modal/index';
import DepartmentModal from './components/operate_modal/department_modal/index';
import ThirdCouponModal from './components/operate_modal/thirdCouponModal/ThirdCouponModal';
import { OPT_DETAIL } from '@/constants';
import {
  TextFieldCom,
  SelectFieldCom,
  RadioFieldCom,
  CheckBoxFieldCom,
  UploadImageCom,
} from '@/components/FormType';
import TitleML from './components/TitleML';
import request from '@/utils/request';
import { getToken } from '@/utils/token';
import Styled from './indexStyles';

//生成唯一id
function guid() {
  return Number(Math.random().toString().substr(3, 3) + Date.now()).toString(
    36,
  );
}

export default () => {
  const theme = useTheme();
  const location = useLocation();
  const { query } = location;
  const { id, opt, type } = query;
  const saveRef = useRef();
  const [dialogStatus, setDialogStatus] = useState(false);
  const [departmentDialogStatus, setDepartmentDialogStatus] = useState(false);
  const [thirdDialogStatus, setThirdDialogStatus] = useState(false);
  const { handleSubmit, control, setValue, watch, getValues, errors, reset } =
    useForm({
      defaultValues: {
        transactionMinimumLimit: '0',
        transactionMinimum: 0,
        isLimitMaxCoupons: '0',
        maxCouponsPerUser: '1',
        discountAmount: 0,
        validBegin: '0',
        validDays: '1',
        isAllGoods: '1',
        quantity: '1',
        departmentLimit: '0',
        addressList: [{ address: '' }],
        hasCalc: '0',
        calcPoint: 0,
        externalConfigType: 'code',
        externalConfigAppId: '',
        externalConfigPath: '',
        thirdFilePath: '',
      },
    });
  const [isSubmit, setIsSubmit] = useState(false);
  const [openDialog, setOpenDialog] = useState();
  const [ticketList, setTicketList] = useState([]);
  const [ticketListSave, setTicketListSave] = useState([]);
  const [thirdCouponList, setThirdCouponList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentListSave, setDepartmentListSave] = useState([]);
  const [pictureList, setPictureList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState();
  const [openPriceDialog, setOpenPriceDialog] = useState(false);

  const [fileList, setFileList] = useState([]);
  //当前视口宽度
  const clientWidth = document.body.clientWidth;
  const clientHeight = document.body.clientHeight;

  const { fields, append, remove } = useFieldArray({
    control: control, // control props comes from useForm (optional: if you are using FormContext)
    name: 'addressList',
  });
  //当前视口高度
  const handlePreviewClose = () => {
    setPreviewUrl();
    setPreviewOpen(false);
  };
  //点击图片预览
  const handlePreview = (imgUrl) => {
    setPreviewUrl(imgUrl);
    setPreviewOpen(true);
  };
  const handleSubmitSuccess = (data) => {
    const params = {
      id,
      title: data.title,
      subTitle: data.subTitle,
      comment: data.comment,
      quantity: data?.quantity ? String(data.quantity).replace(/,/g, '') : 1,
      transactionMinimum:
        data.transactionMinimumLimit === '1'
          ? String(data.transactionMinimum).replace(/,/g, '')
          : 0,
      priceMinimum:
        data.transactionMinimumLimit === '2'
          ? String(data.priceMinimum).replace(/,/g, '')
          : 0,
      isLimitMaxCoupons: Boolean(Number(data.isLimitMaxCoupons)),
      maxCouponsPerUser:
        data.isLimitMaxCoupons === '1' ? data.maxCouponsPerUser : '1',
      discountAmount: data.discountAmount,
      hasCalc: Boolean(Number(data.hasCalc)),
      calcPoint: data.calcPoint,
      validBegin: data.couponGetCheckbox ? data.validBegin : '0',
      validDays: data.couponGetCheckbox ? data.validDays : 0,
      description: data.description,
      beginTime: data.date?.startDate
        ? dayjs(data.date.startDate).format('YYYY-MM-DD 00:00:00')
        : '',
      endTime: data.date?.endDate
        ? dayjs(data.date.endDate).format('YYYY-MM-DD 23:59:59')
        : '',
      goods: data.isAllGoods === '1' ? null : ticketListSave,
      isAllStore: 1,
      memberLimit: 0,
      type:
        {
          2: 'CASH_COUPON',
          4: 'EXCHANGE_COUPON',
          10: 'GIFT_COUPON',
          8: 'EXTERNAL_COUPON',
          11: 'THIRD_PARTY_COUPON',
        }[type] || 'FREE_TICKET_COUPON',
      channelType: 1,
      isAllCompany: 1,
      usedType: [4],
      isAllGoods: ['4', '8', '10', '11'].includes(type) ? '1' : data.isAllGoods,
      goodsNum: 0,
      depInfoResponseList:
        data.departmentLimit === '1' ? departmentListSave : null,
      gift: data.gift,
      pictureList: data?.pictureList?.map((i) => ({ picUrl: i })) || [],
      addressList: data?.addressList?.filter((i) => i.address) || [],
      thirdCouponId: data.thirdPartyCouponInfo?.[0]?.thirdCouponId || null,
      thirdPartyCouponInfo: data.thirdPartyCouponInfo?.[0] || null,

      // 三方礼品券特有参数
      ...(type === '8'
        ? {
            externalConfigType: data.externalConfigType,
            externalConfigAppId: data.externalConfigAppId,
            externalConfigPath: data.externalConfigPath,
            thirdFilePath: fileList?.[0]?.url || null,
          }
        : {}),
    };
    if (
      !['4', '8', '10', '11'].includes(type) &&
      data.isAllGoods !== '1' &&
      (ticketListSave.length === 0 || !ticketListSave)
    ) {
      window.message.toast({
        type: 'error',
        message: '请选择适用票档',
        title: '错误',
      });
      return false;
    }
    if (
      type === '4' &&
      data.departmentLimit === '1' &&
      (departmentListSave.length === 0 || !departmentListSave)
    ) {
      window.message.toast({
        type: 'error',
        message: '请选择核销部门',
        title: '错误',
      });
      return false;
    }
    if (isSubmit) {
      return false;
    }
    setIsSubmit(true);
    const url = id ? '/coupon/update' : '/coupon/add';
    request(url, {
      method: 'POST',
      data: params,
    })
      .then((res) => {
        if (res?.code === 0) {
          window.message.toast({
            type: 'success',
            message: id ? '更新成功' : '新建成功',
            title: '成功',
          });
          setTimeout(() => {
            history.goBack();
          }, 2000);
        }
      })
      .finally(() => {
        setIsSubmit(false);
      });
  };

  const handleSubmitFail = () => {
    setIsSubmit(false);
  };

  useEffect(() => {
    const initData = async () => {
      if (id) {
        const detail = await request('/coupon/queryDetail', {
          method: 'POST',
          data: {
            id,
          },
        });
        const title = detail.data.title;
        const subTitle = detail.data.subTitle;
        const comment = detail.data.comment;
        const quantity = detail.data?.quantity
          ? fmtThousand(Number(detail.data?.quantity))
          : '1';
        const transactionMinimum = detail.data.transactionMinimum;
        const priceMinimum = detail.data.priceMinimum;
        const transactionMinimumLimit =
          detail.data.transactionMinimum > 0
            ? '1'
            : detail.data.priceMinimum > 0
            ? '2'
            : '0';
        const isLimitMaxCoupons = String(Number(detail.data.isLimitMaxCoupons));
        const maxCouponsPerUser = detail.data.maxCouponsPerUser || '1';
        const discountAmount = detail.data.discountAmount;
        const hasCalc = String(Number(detail.data.hasCalc));
        const calcPoint = detail.data.calcPoint;
        const validBegin = String(detail.data.validBegin);
        const validDays = detail.data.validDays;
        const description = detail.data.description;
        const date = {
          startDate: detail.data.beginTime,
          endDate: detail.data.endTime,
        };
        const isAllGoods = String(detail.data.isAllGoods);
        const couponGetCheckbox =
          Number(detail.data.validDays) > 0 ? ['1'] : '';
        const gift = detail.data.gift;
        const depInfoResponseList = detail.data.depInfoResponseList;
        const pl = detail.data.pictureList?.map((i) => i.picUrl) || [];
        const addressList = detail.data.addressList || [{ address: '' }];
        const thirdPartyCouponInfo = detail.data.thirdPartyCouponInfo || '';
        setThirdCouponList(thirdPartyCouponInfo ? [thirdPartyCouponInfo] : []);
        setTicketList(detail.data.goods || []);
        setTicketListSave(detail.data.goods || []);
        setDepartmentList(depInfoResponseList || []);
        setDepartmentListSave(depInfoResponseList || []);

        // 三方礼品券特有参数
        const externalConfigType = detail.data.externalConfigType || 'code';
        const externalConfigAppId = detail.data.externalConfigAppId || '';
        const externalConfigPath = detail.data.externalConfigPath || '';
        setFileList([
          {
            id: guid(),
            url: detail.data.thirdFilePath,
            fileName: detail.data.thirdFilePath,
          },
        ]);
        setPictureList(pl);
        reset({
          title,
          subTitle,
          comment,
          quantity,
          transactionMinimum,
          transactionMinimumLimit,
          priceMinimum,
          isLimitMaxCoupons,
          maxCouponsPerUser,
          discountAmount,
          hasCalc,
          calcPoint,
          validBegin,
          validDays,
          description,
          date,
          couponGetCheckbox,
          isAllGoods,
          gift,
          departmentLimit: depInfoResponseList ? '1' : '0',
          pictureList: pl,
          addressList,
          thirdPartyCouponInfo: thirdPartyCouponInfo
            ? [thirdPartyCouponInfo]
            : '',
          externalConfigType,
          externalConfigAppId,
          externalConfigPath,
        });
      }
    };
    initData();
  }, [id]);

  //关于退出
  const handleExitClick = () => {
    if (opt !== OPT_DETAIL) {
      setOpenDialog(true);
    } else {
      history.goBack();
    }
  };

  //点击添加剧目
  const handleClickAdd = () => {
    setDialogStatus(true);
  };
  //点击添加部门
  const handleClickAddDepartment = () => {
    setDepartmentDialogStatus(true);
  };
  //关闭剧目选择弹窗
  const handleCancel = () => {
    setDialogStatus(false);
  };
  //关闭剧目选择弹窗
  const handleClose = () => {
    setDialogStatus(false);
  };
  //关闭部门选择弹窗
  const handleDepartmentClose = () => {
    setDepartmentDialogStatus(false);
  };
  const handleAddTicket = (selectList) => {
    // Sort selectList by proNo and featureDate+featureTime
    if (watch('isAllGoods') !== '2') {
      const sortedList = [...selectList].sort((a, b) => {
        if (a.proNo === b.proNo) {
          const aDateTime = `${a.featureDate} ${a.featureTime}`;
          const bDateTime = `${b.featureDate} ${b.featureTime}`;
          return new Date(bDateTime) - new Date(aDateTime); // Descending order
        }
        return a.proNo.localeCompare(b.proNo);
      });
      setTicketListSave(sortedList);
      setTicketList(sortedList);
    } else {
      setTicketListSave(selectList);
      setTicketList(selectList);
    }

    setDialogStatus(false);
  };
  const handleAddDepartment = (selectList) => {
    setDepartmentListSave(selectList);
    setDepartmentList(selectList);
    setDepartmentDialogStatus(false);
  };

  const departmentColumns = [
    {
      title: '部门编号',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '部门名称',
      dataIndex: 'depName',
      key: 'depName',
    },
    {
      title: '部门人数',
      dataIndex: 'count',
      key: 'count',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <IconButton aria-label="delete" disabled={opt === OPT_DETAIL}>
          <SvgIconML
            name="circleDelete"
            size={22}
            fill={
              opt !== OPT_DETAIL
                ? theme.palette.primary.main
                : theme.palette.secondary.disabled
            }
            className="preview"
            onClick={() => {
              setDepartmentList(
                departmentList.filter((item) => item.id !== record.id),
              );
              setDepartmentListSave(
                departmentListSave.filter((item) => item.id !== record.id),
              );
            }}
          />
        </IconButton>
      ),
    },
  ];
  const columns = [
    ...(watch('isAllGoods') !== '2'
      ? [
          {
            title: '剧目编码',
            dataIndex: 'proNo',
            key: 'proNo',
          },
          {
            title: '剧目名称',
            dataIndex: 'proName',
            key: 'proName',
          },
          {
            title: '场次编码',
            dataIndex: 'featureNo',
            key: 'featureNo',
          },
          {
            title: '场次时间',
            key: 'featureTime',
            dataIndex: 'featureTime',
            render: (_, record) => {
              return `${record.featureDate} ${record.featureTime}`;
            },
          },
          {
            title: '票档',
            key: 'price',
            dataIndex: 'price',
          },
        ]
      : [
          {
            title: '剧目编码',
            dataIndex: 'proNo',
            key: 'proNo',
          },
          {
            title: '剧目名称',
            dataIndex: 'proName',
            key: 'proName',
          },
          {
            title: '演出时间',
            dataIndex: 'featureTime',
            key: 'featureTime',
            width: 220,
            render: (_, record) => {
              return `${record.proStartDate || ''} ${record.proEndDate || ''}`;
            },
          },
        ]),
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <IconButton aria-label="delete" disabled={opt === OPT_DETAIL}>
          <SvgIconML
            name="circleDelete"
            size={22}
            fill={
              opt !== OPT_DETAIL
                ? theme.palette.primary.main
                : theme.palette.secondary.disabled
            }
            className="preview"
            onClick={() => {
              const key = watch('isAllGoods') !== '2' ? 'id' : 'proNo';
              setTicketList(
                ticketList.filter((item) => item[key] !== record[key]),
              );
              setTicketListSave(
                ticketListSave.filter((item) => item[key] !== record[key]),
              );
            }}
          />
        </IconButton>
      ),
    },
  ];

  const clearArrayData = (obj) => {
    if (errors?.addressList) {
      const index = obj?.key;
      const newErrors = { ...errors };
      if (newErrors.addressList[index]) {
        delete newErrors.addressList[index];
        if (Object.keys(newErrors.addressList).length === 0) {
          delete newErrors.addressList;
        }
      }
    }
  };

  const handleClickAddThirdCoupon = () => {
    const list = watch('thirdPartyCouponInfo') || [];
    setThirdCouponList(list);
    setThirdDialogStatus(true);
  };
  const handleClickAddThirdDelete = () => {
    setThirdCouponList([]);
    setValue('thirdPartyCouponInfo', '');
  };

  const handleCloseThirdCoupon = () => {
    setThirdDialogStatus(false);
  };

  const handleAddThirdCoupon = () => {
    setValue('thirdPartyCouponInfo', thirdCouponList);
  };

  const getFileName = (str) => {
    const startIndex = str.indexOf('/') + 1;
    const endIndex = str.lastIndexOf('_');
    const middleContent = str.substring(startIndex, endIndex);

    // 拼接点号后面的内容
    const dotIndex = str.lastIndexOf('.') + 1;
    const extension = str.substring(dotIndex);
    if (!middleContent) {
      return str;
    }
    const result = middleContent + '.' + extension;
    return result;
  };

  // 下载模版
  const handleClickDownload = () => {
    if (opt === OPT_DETAIL) {
      return;
    }
    download('/common/importThirdCardTemplate', {
      fileType: getValues('fileType'),
    });
  };

  // 上传文件
  const uploadFile = (formData, fileName) => {
    if (opt !== OPT_DETAIL) {
      request('/common/upload', {
        method: 'POST',
        data: formData,
      })
        .then((res) => {
          if (res.code === 0) {
            const fileObj = { id: guid(), ...res.data, fileName };
            setFileList([fileObj]);
            document.getElementById('inputFile').value = null;
            setValue('url', JSON.stringify(fileList));
          } else {
            window.message.toast({
              type: 'error',
              message: res.message,
              title: '失败',
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  //删除文件
  const handleFileListDelete = ({ selfId }) => {
    const list = fileList.filter((item) => item.id !== selfId);
    setFileList([...list]);
    setValue('url', list.length > 0 ? JSON.stringify(list) : '');
  };

  //下载文件
  const handleDownloadUrl = ({ selfId }) => {
    fileList.forEach((item) => {
      if (item.id === selfId) {
        const apiToken = `${getToken()}`;
        const a = document.createElement('a');
        a.download = item.fileName;
        a.href = `${
          window.location.origin
        }/bizgrowth/web/v1/common/download?uri=${encodeURIComponent(
          item.url,
        )}&access_token=${apiToken}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    });
  };

  const thirdPartyCouponInfo = watch('thirdPartyCouponInfo');
  const thirdInfor = useMemo(() => {
    return thirdPartyCouponInfo?.[0] || null;
  }, [thirdPartyCouponInfo]);

  return (
    <Styled theme={theme}>
      <Box>
        <form onSubmit={handleSubmit(handleSubmitSuccess, handleSubmitFail)}>
          <Box className="coupons-setting-box">
            <TitleML title="基本设置" fontSize="18px" />
            <Box className="coupons-setting-box-4fr">
              <TextFieldCom
                control={control}
                label="优惠券名称"
                name="title"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                rules={{ required: true, maxLength: 50 }}
                initErrorText="名称必填不超过50个字"
                disabled={opt === OPT_DETAIL}
              />
              <TextFieldCom
                control={control}
                label="优惠券副标题"
                name="subTitle"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                rules={{
                  maxLength: 15,
                }}
                initErrorText="副标题必填不超过15个字"
                disabled={opt === OPT_DETAIL}
              />
              <TextFieldCom
                control={control}
                label="优惠券备注"
                name="comment"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                rules={{ maxLength: 15 }}
                disabled={opt === OPT_DETAIL}
              />
              {['8'].includes(type) ? null : (
                <TextFieldCom
                  className
                  control={control}
                  label="发放总数"
                  name="quantity"
                  isNumber={true}
                  isPositiveNumber={true}
                  isParseInt={true}
                  thousands={true}
                  getValues={getValues}
                  setValue={setValue}
                  errors={errors}
                  rules={{ required: true, max: 1000000, min: 1 }}
                  initErrorText="发放数量必填不超过7位数"
                  disabled={opt === OPT_DETAIL}
                />
              )}
            </Box>

            <Box mt={4} className="coupons-setting-box-display-flex">
              <div
                style={{
                  display: ['8', '10', '11'].includes(type) ? 'none' : 'block',
                }}
              >
                <RadioFieldCom
                  errors={errors}
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  disabled={opt === OPT_DETAIL}
                  initLabel="使用限制"
                  label="使用限制"
                  name="transactionMinimumLimit"
                  typeList={[
                    { label: '无使用门槛', value: '0' },
                    { label: '订单满', value: '1' },
                    { label: '票档满', value: '2' },
                  ]}
                >
                  <div key={0}></div>
                  <div className="radio-text-wrap" key={1}>
                    <TextFieldCom
                      style={{ width: '100px', marginLeft: '4px' }}
                      control={control}
                      showLabel={false}
                      label="订单满_元可用"
                      initErrorText="金额需≥0且小于9999999"
                      name="transactionMinimum"
                      isNumber={true}
                      isPositiveNumber={true}
                      isParseInt={true}
                      thousands={true}
                      errors={errors}
                      endAdornment={
                        <Box color="#000" fontSize="14px">
                          元
                        </Box>
                      }
                      getValues={getValues}
                      setValue={setValue}
                      rules={{
                        min:
                          watch('transactionMinimumLimit') === '1' ? 0 : null,
                        required: watch('transactionMinimumLimit') === '1',
                        maxLength: 7,
                      }}
                      disabled={opt === OPT_DETAIL}
                    />
                    <span className="radio-text-end-text">可用</span>
                  </div>
                  <div className="radio-text-wrap" key={2}>
                    <TextFieldCom
                      style={{ width: '100px', marginLeft: '4px' }}
                      control={control}
                      showLabel={false}
                      label="票档满_元可用"
                      initErrorText="金额需≥0且小于9999999"
                      name="priceMinimum"
                      isNumber={true}
                      isPositiveNumber={true}
                      isParseInt={true}
                      thousands={true}
                      errors={errors}
                      endAdornment={
                        <Box color="#000" fontSize="14px">
                          元
                        </Box>
                      }
                      getValues={getValues}
                      setValue={setValue}
                      rules={{
                        min:
                          watch('transactionMinimumLimit') === '2' ? 0 : null,
                        required: watch('transactionMinimumLimit') === '2',
                        maxLength: 7,
                      }}
                      disabled={opt === OPT_DETAIL}
                    />
                    <span className="radio-text-end-text">可用</span>
                  </div>
                </RadioFieldCom>
              </div>
              <RadioFieldCom
                errors={errors}
                control={control}
                getValues={getValues}
                setValue={setValue}
                disabled={opt === OPT_DETAIL}
                initLabel="领取数量限制"
                label="领取数量限制"
                name="isLimitMaxCoupons"
                typeList={[
                  { label: '不限制', value: '0' },
                  { label: '每人最多领', value: '1' },
                ]}
              >
                <div key={0}></div>
                <div className="radio-text-wrap" key={1}>
                  <TextFieldCom
                    style={{ width: '100px', marginLeft: '4px' }}
                    control={control}
                    showLabel={false}
                    label="每人最多领_张"
                    name="maxCouponsPerUser"
                    initErrorText="领取数需为正整数"
                    isNumber={true}
                    isPositiveNumber={true}
                    isParseInt={true}
                    thousands={true}
                    errors={errors}
                    endAdornment={
                      <Box color="#000" fontSize="14px">
                        张
                      </Box>
                    }
                    getValues={getValues}
                    setValue={setValue}
                    rules={{
                      min: 1,
                      required: watch('isLimitMaxCoupons') === '1',
                      maxLength: 4,
                    }}
                    disabled={opt === OPT_DETAIL}
                  />
                </div>
              </RadioFieldCom>
            </Box>
            {!['4', '8', '10', '11'].includes(type) ? (
              <Box
                mt={5}
                className={
                  type === '9' ? 'coupons-setting-box-display-flex' : ''
                }
              >
                <Box>
                  <Box fontSize="14px" color="#666" mb={1}>
                    <span style={{ color: 'red' }}>*</span>
                    优惠券内容
                  </Box>
                  <Box fontSize="14px" color="#999" mb={1}>
                    针对所选剧目、场次、档位的优惠券免票
                  </Box>
                  {type === '2' && (
                    <Box display="flex" alignItems="center" gap="0 3px">
                      <span style={{ fontSize: '14px', color: '#000' }}>
                        减免
                      </span>
                      <TextFieldCom
                        control={control}
                        showLabel={false}
                        label="减免_元"
                        initErrorText="优惠减免是必填项"
                        name="discountAmount"
                        isNumber={true}
                        isPositiveNumber={true}
                        endAdornment={
                          <Box color="#000" fontSize="14px">
                            元
                          </Box>
                        }
                        isParseInt={true}
                        getValues={getValues}
                        setValue={setValue}
                        errors={errors}
                        rules={{ required: true, min: 0 }}
                        disabled={opt === OPT_DETAIL}
                      />
                      <span style={{ fontSize: '14px', color: '#999' }}>
                        优惠内容是商家单独给消费者的优惠券金额，当设置大额优惠金额时需谨慎
                      </span>
                    </Box>
                  )}
                </Box>
                {type === '9' ? (
                  <RadioFieldCom
                    errors={errors}
                    control={control}
                    getValues={getValues}
                    setValue={setValue}
                    disabled={opt === OPT_DETAIL}
                    initLabel="累计积分"
                    label="累计积分"
                    name="hasCalc"
                    typeList={[
                      { label: '不累计', value: '0' },
                      { label: '核销后累计', value: '1' },
                    ]}
                  >
                    <div key={0}></div>
                    <div className="radio-text-wrap" key={1}>
                      <TextFieldCom
                        style={{ width: '100px', marginLeft: '4px' }}
                        control={control}
                        showLabel={false}
                        label="核销后累计_分"
                        name="calcPoint"
                        initErrorText="核销后累计数是必填项"
                        isNumber={true}
                        isPositiveNumber={true}
                        isParseInt={true}
                        errors={errors}
                        endAdornment={
                          <Box color="#000" fontSize="14px">
                            分
                          </Box>
                        }
                        getValues={getValues}
                        setValue={setValue}
                        rules={{
                          min: 0,
                          max: 999999,
                          required: watch('hasCalc') === '1',
                        }}
                        disabled={opt === OPT_DETAIL}
                      />
                    </div>
                  </RadioFieldCom>
                ) : (
                  ''
                )}
              </Box>
            ) : (
              ''
            )}

            {['4', '11'].includes(type) ? (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4, 1fr)',
                  gap: '32px',
                  marginTop: '23px',
                }}
              >
                <TextFieldCom
                  control={control}
                  label="礼品描述"
                  name="gift"
                  getValues={getValues}
                  setValue={setValue}
                  errors={errors}
                  rules={{ required: true, maxLength: 15 }}
                  disabled={opt === OPT_DETAIL}
                />
                <div></div>
                <div></div>
                <div></div>
              </Box>
            ) : null}

            {type === '8' ? (
              <>
                <Box mt={5} className="coupons-setting-box-display-flex">
                  <RadioFieldCom
                    errors={errors}
                    control={control}
                    getValues={getValues}
                    setValue={setValue}
                    initLabel="跳转类型"
                    label="跳转类型"
                    name="externalConfigType"
                    typeList={[
                      { label: '不跳转', value: 'code' },
                      { label: '微信红包', value: 'red' },
                      { label: '小程序跳转', value: 'path' },
                    ]}
                  />
                </Box>
                <Box className="coupons-setting-box-3fr">
                  <TextFieldCom
                    control={control}
                    label="AppId"
                    name="externalConfigAppId"
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    disabled={opt === OPT_DETAIL}
                  />
                  <TextFieldCom
                    control={control}
                    label="Path"
                    name="externalConfigPath"
                    getValues={getValues}
                    setValue={setValue}
                    errors={errors}
                    disabled={opt === OPT_DETAIL}
                  />
                </Box>
                <Box mt={5}>
                  <Controller
                    render={(pr) => (
                      <UploadImageCom
                        uW="150"
                        uH="150"
                        iW="150"
                        iH="150"
                        pr={pr}
                        label={
                          <>
                            <span>图片</span>
                            <span
                              style={{ marginLeft: '8px', color: '#999999' }}
                            >
                              建议尺寸1080*1042px,大小10M以内
                            </span>
                          </>
                        }
                        disabled={opt === OPT_DETAIL}
                        getValues={getValues}
                        maxNumber="10"
                        fileSize={10 * 1024 * 1024}
                        handlePreview={handlePreview}
                        defaultValues={pictureList}
                        showSuccessNumber
                        bucket="EXCHANGE-COUPON-FILE"
                        required={true}
                      />
                    )}
                    name="pictureList"
                    control={control}
                    rules={{
                      required: true,
                    }}
                  />
                  <FormHelperText error={Boolean(errors.coverImage)}>
                    {errors.coverImage && '请选择图片'}
                  </FormHelperText>
                </Box>
              </>
            ) : null}

            <Box mt={4} width="788px">
              <Box className="title-text-wrap" style={{ marginBottom: '24px' }}>
                <span className="required-text">*</span>
                用券时间
              </Box>
              <Box className="coupons-setting-box-2fr">
                <FormControl variant="standard">
                  <Controller
                    render={(rp) => (
                      <DateRangePickerML
                        startText="开始时间"
                        endText="结束时间"
                        defaultStartDate={rp?.value?.startDate}
                        defaultEndDate={rp?.value?.endDate}
                        rp={rp}
                        setValue={setValue}
                        name="custom-form-submit-name"
                        disabled={opt === OPT_DETAIL}
                      />
                    )}
                    name="date"
                    control={control}
                    rules={{
                      validate: () => {
                        const status = !(
                          !getValues('date') ||
                          getValues('date')?.startDate === null ||
                          getValues('date')?.endDate === null
                        );
                        return status;
                      },
                    }}
                  />
                  {Boolean(errors?.date) && (
                    <FormHelperText
                      sx={{ fontSize: '12px', marginTop: '7px' }}
                      error={Boolean(errors?.date)}
                    >
                      请选择有效日期
                    </FormHelperText>
                  )}
                </FormControl>
                <Box
                  display="flex"
                  visibility={type === '11' ? 'hidden' : 'visible'}
                  gap="0 4px"
                  position="relative"
                  top="14px"
                >
                  <CheckBoxFieldCom
                    control={control}
                    name="couponGetCheckbox"
                    checkedBoxList={[
                      {
                        label: '领券',
                        value: '1',
                      },
                    ]}
                    setValue={setValue}
                    getValues={getValues}
                    disabled={opt === OPT_DETAIL}
                  />
                  <div style={{ flex: 1, position: 'relative', top: '-10px' }}>
                    <SelectFieldCom
                      control={control}
                      name="validBegin"
                      watchAllFields={watch()}
                      typeList={[
                        {
                          name: '当日',
                          value: '0',
                        },
                        {
                          name: '次日',
                          value: '1',
                        },
                      ]}
                      setValue={setValue}
                      getValues={getValues}
                      rules={{ required: watch('couponGetCheckbox') }}
                      errors={errors}
                      initErrorText="此选项不能为空"
                      showStar={false}
                      disabled={opt === OPT_DETAIL}
                    />
                  </div>
                  <span className="radio-text-end-text" style={{ top: '10px' }}>
                    起
                  </span>
                  <Box sx={{ position: 'relative', top: '5px', flex: 1 }}>
                    <TextFieldCom
                      style={{ width: '100%' }}
                      control={control}
                      showLabel={false}
                      label="有效期_天"
                      initErrorText="天数需≥1"
                      name="validDays"
                      isNumber={true}
                      isPositiveNumber={true}
                      endAdornment={
                        <Box color="#000" fontSize="14px">
                          天
                        </Box>
                      }
                      isParseInt={true}
                      getValues={getValues}
                      setValue={setValue}
                      errors={errors}
                      rules={{
                        required: watch('couponGetCheckbox'),
                        min: null,
                      }}
                      disabled={opt === OPT_DETAIL}
                    />
                  </Box>
                  <span className="radio-text-end-text" style={{ top: '10px' }}>
                    内可用
                  </span>
                </Box>
              </Box>
            </Box>

            {type === '4' ? (
              <Box mt={5}>
                <Controller
                  render={(pr) => (
                    <UploadImageCom
                      uW="150"
                      uH="150"
                      iW="150"
                      iH="150"
                      pr={pr}
                      label={
                        <>
                          <span>图片</span>
                          <span style={{ marginLeft: '8px', color: '#999999' }}>
                            建议尺寸1080*1042px,大小10M以内
                          </span>
                        </>
                      }
                      disabled={opt === OPT_DETAIL}
                      getValues={getValues}
                      maxNumber="10"
                      fileSize={10 * 1024 * 1024}
                      handlePreview={handlePreview}
                      defaultValues={pictureList}
                      showSuccessNumber
                      bucket="EXCHANGE-COUPON-FILE"
                    />
                  )}
                  name="pictureList"
                  control={control}
                />
              </Box>
            ) : (
              ''
            )}

            {type === '4' ? (
              <Box mt={5}>
                <div
                  style={{
                    fontSize: '16px',
                    color: '#212100',
                    marginBottom: '12px',
                  }}
                >
                  地址配置
                </div>
                <Box
                  border=" 1px solid #CCCCCC"
                  borderRadius="12px"
                  // width="1096px"
                  padding="25px 48px 24px 24px"
                  display="flex"
                  flexDirection="column"
                  gap="25px 0"
                >
                  {fields.map((item, index) => (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      key={item.id}
                    >
                      <Box
                        display="flex"
                        gap="0 48px"
                        width="100%"
                        paddingRight="16px"
                      >
                        <Box width="100%">
                          <TextFieldCom
                            key={index}
                            control={control}
                            name={`addressList.${index}.address`}
                            getValues={getValues}
                            setValue={setValue}
                            errors={
                              errors?.addressList?.[index]?.address
                                ? {
                                    [`addressList.${index}.address`]:
                                      errors.addressList[index].address,
                                  }
                                : {}
                            }
                            disabled={opt === OPT_DETAIL}
                            defaultValue={item.address}
                            placeholder="请输入地址"
                            rules={{
                              maxLength: 100,
                            }}
                            parameter={{ key: index }}
                            clearArrayData={clearArrayData}
                          />
                        </Box>
                      </Box>
                      <Box display="flex" gap="0 16px" alignItems="flex-end">
                        {fields?.length < 10 && (
                          <Box className="params-icon-wrap">
                            <AddIcon
                              width="100%"
                              height="100%"
                              htmlColor={
                                opt === OPT_DETAIL
                                  ? 'rgba(0, 0, 0, 0.38)'
                                  : 'rgba(0, 0, 0, 0.87)'
                              }
                              onClick={() =>
                                opt !== OPT_DETAIL && append({ address: '' })
                              }
                            />
                          </Box>
                        )}
                        {fields?.length > 1 && (
                          <Box className="params-icon-wrap">
                            <RemoveIcon
                              width="100%"
                              height="100%"
                              htmlColor={
                                opt === OPT_DETAIL
                                  ? 'rgba(0, 0, 0, 0.38)'
                                  : 'rgba(0, 0, 0, 0.87)'
                              }
                              onClick={() =>
                                opt !== OPT_DETAIL && remove(index)
                              }
                            />
                          </Box>
                        )}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            ) : null}

            <Box mt={4}>
              <TextFieldCom
                control={control}
                label="使用说明"
                name="description"
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                multiline
                maxRows={10}
                minRows={10}
                variant="outlined"
                rules={{ maxLength: 2000, required: true }}
                initErrorText="使用说明不超过2000字"
                disabled={opt === OPT_DETAIL}
              />
            </Box>
            {/* <TitleML title="适用票档" fontSize="19px" /> */}
            {type === '4' ? (
              <Box mt={4}>
                <RadioFieldCom
                  errors={errors}
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  disabled={opt === OPT_DETAIL}
                  initLabel="核销部门"
                  label="核销部门"
                  name="departmentLimit"
                  labelRow="flex"
                  typeList={[
                    { label: '不限制', value: '0' },
                    { label: '限制', value: '1' },
                  ]}
                  callback={() => {
                    setTicketListSave([]);
                    setTicketList([]);
                  }}
                ></RadioFieldCom>
                {watch('departmentLimit') !== '0' && (
                  <Box mb={4}>
                    <Box mb={2}>
                      <Fab
                        variant="extended"
                        size="small"
                        color="primary"
                        aria-label="add"
                        className="export"
                        sx={{ marginRight: '16px' }}
                        onClick={handleClickAddDepartment}
                        disabled={opt === OPT_DETAIL}
                      >
                        <AddIcon sx={{ width: '24px', height: '24px' }} />
                        添加
                      </Fab>
                    </Box>
                    <Table
                      columns={departmentColumns}
                      dataSource={departmentListSave}
                      size="small"
                      // pagination={false}
                    />
                  </Box>
                )}
              </Box>
            ) : !['8', '10', '11'].includes(type) ? (
              <div style={{ marginTop: '32px' }}>
                <RadioFieldCom
                  errors={errors}
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  disabled={opt === OPT_DETAIL}
                  initLabel="适用票档"
                  label="适用票档"
                  name="isAllGoods"
                  labelRow="flex"
                  typeList={[
                    { label: '全部可用', value: '1' },
                    { label: '仅限指定剧目可用', value: '2' },
                    { label: '仅限指定票档可用', value: '0' },
                  ]}
                  callback={() => {
                    setTicketListSave([]);
                    setTicketList([]);
                  }}
                ></RadioFieldCom>
                {watch('isAllGoods') !== '1' && (
                  <Box mb={5}>
                    <Box mb={2}>
                      <Fab
                        variant="extended"
                        size="small"
                        color="primary"
                        aria-label="add"
                        className="export"
                        sx={{ marginRight: '16px' }}
                        onClick={handleClickAdd}
                        disabled={opt === OPT_DETAIL}
                      >
                        <AddIcon sx={{ width: '24px', height: '24px' }} />
                        添加
                      </Fab>
                    </Box>
                    <Table
                      columns={columns}
                      dataSource={ticketListSave}
                      size="small"
                      // pagination={false}
                    />
                  </Box>
                )}
              </div>
            ) : (
              ''
            )}
            {type === '10' ? (
              <Box mt={4}>
                <Controller
                  render={(pr) => (
                    <UploadImageCom
                      uW="150"
                      uH="150"
                      iW="150"
                      iH="150"
                      acceptType={['png', 'jpg']}
                      pr={pr}
                      label={
                        <>
                          <span>轮播图</span>
                          <span style={{ marginLeft: '8px', color: '#999999' }}>
                            建议上传尺寸为1080*1042px,大小10M以内的图片
                          </span>
                        </>
                      }
                      disabled={opt === OPT_DETAIL}
                      getValues={getValues}
                      maxNumber="10"
                      fileSize={10 * 1024 * 1024}
                      handlePreview={handlePreview}
                      defaultValues={pictureList}
                      showSuccessNumber
                      bucket="EXCHANGE-COUPON-FILE"
                    />
                  )}
                  name="pictureList"
                  control={control}
                />
              </Box>
            ) : null}

            {type === '8' ? (
              <Box mt={4}>
                <Box className="title-text-wrap">上传券码文件</Box>
                <div className="export-wrapper">
                  <Fab
                    variant="extended"
                    size="small"
                    color={opt === 'detail' ? '#fff' : 'primary'}
                    aria-label="add"
                    className="download"
                    sx={{ mr: 1.6 }}
                    onClick={handleClickDownload}
                    disabled={opt === OPT_DETAIL ? 'disabled' : null}
                  >
                    <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
                    下载样例
                  </Fab>
                  <Fab
                    variant="extended"
                    size="small"
                    color={opt === 'detail' ? '#fff' : 'primary'}
                    aria-label="add"
                    className="uploadFile"
                    sx={{ position: 'relative' }}
                    disabled={opt === OPT_DETAIL ? 'disabled' : null}
                  >
                    <Controller
                      render={(rp) => {
                        return (
                          <input
                            className="fileInput"
                            name="url"
                            style={{
                              position: 'absolute',
                              left: '0px',
                              top: '0px',
                              opacity: 0,
                            }}
                            disabled={opt === OPT_DETAIL}
                            type="file"
                            id="inputFile"
                            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            label="上传文件"
                            onChange={(e) => {
                              let file = e.target.files;
                              let formData = new FormData(); //{}
                              const fileName = file[0].name; //文件名 MemberBlackTemplate.csv
                              if (file) {
                                const reader = new FileReader();
                                reader.readAsBinaryString(file[0]);
                                reader.onload = function (ed) {
                                  try {
                                    const data = ed.target.result;
                                    const workbook = XLSX.read(data, {
                                      type: 'binary',
                                    });
                                    const sheetName = workbook.SheetNames[0];
                                    const worksheet =
                                      workbook.Sheets[sheetName];
                                    const range = XLSX.utils.decode_range(
                                      worksheet['!ref'],
                                    );
                                    const rowCount = range.e.r + 1;
                                    if (!rowCount || rowCount < 2) {
                                      window.message.toast({
                                        type: 'error',
                                        message: '上传的文件中没有数据',
                                        title: '',
                                      });
                                      document.getElementById(
                                        'inputFile',
                                      ).value = null;
                                      return;
                                    }
                                    formData.append('file', file[0]);
                                    formData.append('isFixedName', false);
                                    formData.append('isPublic', true);
                                    formData.append(
                                      'bucket',
                                      'MESSAGE_LINK_FILE',
                                    );
                                    uploadFile(formData, fileName);
                                  } catch (error) {
                                    formData.append('file', file[0]);
                                    formData.append('isFixedName', false);
                                    formData.append('isPublic', true);
                                    formData.append(
                                      'bucket',
                                      'MESSAGE_LINK_FILE',
                                    );
                                    uploadFile(formData, fileName);
                                  }
                                };
                              }
                              return rp.onChange(e);
                            }}
                          />
                        );
                      }}
                      name="url"
                      type="file"
                      label="上传文件"
                      control={control}
                      rules={{ required: true }}
                    />
                    <UnarchiveIcon sx={{ width: '24px', height: '24px' }} />
                    上传文件
                  </Fab>
                  <FormHelperText
                    error={Boolean(errors.url)}
                    sx={{ marginTop: '8px' }}
                  >
                    {Boolean(errors?.url?.type === 'required') &&
                      '上传文件为必填项'}
                  </FormHelperText>
                </div>
                {fileList?.map((item) => {
                  return (
                    <Box
                      className="file_name"
                      mt={2.6}
                      style={{
                        color: '##1565c0',
                      }}
                      key={item.id}
                    >
                      <span
                        style={{
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          handleDownloadUrl({ selfId: item.id });
                        }}
                      >
                        {item.fileName && getFileName(item.fileName)}
                      </span>
                      {opt === OPT_DETAIL ? (
                        ''
                      ) : (
                        <HighlightOffIcon
                          sx={{
                            width: '24px',
                            height: '24px',
                            color: 'rgba(0, 0, 0, 0.26)',
                            marginLeft: '9px',
                            cursor: 'pointer',
                            verticalAlign: 'middle',
                          }}
                          key={item.id}
                          onClick={() => {
                            handleFileListDelete({ selfId: item.id });
                          }}
                        />
                      )}
                    </Box>
                  );
                })}
              </Box>
            ) : null}

            {type === '11' ? (
              <Box mt={4} width="320px">
                <Box
                  fontSize="16px"
                  color="#333"
                  mb={1.5}
                  height={16}
                  lineHeight={1}
                >
                  <span style={{ color: 'red' }}>*</span>
                  关联第三方券
                </Box>
                <Box
                  className={`third-coupon-card ${
                    thirdInfor ? 'third-coupon-card-data' : ''
                  }`}
                >
                  <Controller
                    control={control}
                    name="thirdPartyCouponInfo"
                    as={
                      <Box className="third-coupon-control">
                        <Box className="third-coupon-info">
                          <Box className="third-coupon-label">品牌</Box>
                          <Box className="third-coupon-content">
                            {thirdInfor?.thirdCouponChannelName || ''}
                          </Box>
                        </Box>
                        <Box className="third-coupon-info">
                          <Box className="third-coupon-label">优惠券ID</Box>
                          <Box className="third-coupon-content">
                            {thirdInfor?.thirdCouponId || ''}
                          </Box>
                        </Box>
                        <Box className="third-coupon-info">
                          <Box className="third-coupon-label">优惠券名称</Box>
                          <Box className="third-coupon-content">
                            {thirdInfor?.thirdCouponName || ''}
                          </Box>
                        </Box>
                        <Box className="third-coupon-tag">
                          <span>三</span>
                          <span>方</span>
                          <span>券</span>
                        </Box>
                      </Box>
                    }
                    rules={{
                      required: type === '11',
                    }}
                  />
                </Box>
                <Box
                  mt={1.5}
                  textAlign="end"
                  style={{ display: opt === OPT_DETAIL ? 'none' : 'block' }}
                >
                  <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="add"
                    className="export"
                    sx={{
                      width: '68px',
                      display: thirdInfor ? 'none' : 'inline-block',
                    }}
                    onClick={handleClickAddThirdCoupon}
                    disabled={opt === OPT_DETAIL}
                  >
                    关联
                  </Fab>
                  <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="add"
                    className="third-coupon-change"
                    sx={{ display: !thirdInfor ? 'none' : 'inline-block' }}
                    onClick={handleClickAddThirdCoupon}
                    disabled={opt === OPT_DETAIL}
                  >
                    替换
                  </Fab>
                  <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="add"
                    className="third-coupon-delete"
                    style={{ display: !thirdInfor ? 'none' : 'inline-block' }}
                    onClick={handleClickAddThirdDelete}
                    disabled={opt === OPT_DETAIL}
                  >
                    删除
                  </Fab>
                </Box>
                <FormHelperText
                  sx={{
                    fontSize: '12px',
                    marginTop: '7px',
                    visibility: errors?.thirdPartyCouponInfo
                      ? 'visible'
                      : 'hidden',
                  }}
                  error={Boolean(errors?.thirdPartyCouponInfo)}
                >
                  请选择优惠券
                </FormHelperText>
              </Box>
            ) : null}
          </Box>
          <Box
            display="flex"
            gap="0 16px"
            borderRadius="12px"
            bgcolor="background.paper"
            p={[3, 4]}
            mt={1.5}
          >
            {opt !== OPT_DETAIL && (
              <>
                {type === '9' ? (
                  <Button
                    variant="contained"
                    className="coupons-setting-button"
                    startIcon={
                      <DoneIcon sx={{ width: '16px', height: '16px' }} />
                    }
                    onClick={() => {
                      if (watch('isAllGoods') !== '1') {
                        saveRef.current.click();
                      } else {
                        setOpenPriceDialog(true);
                      }
                    }}
                  >
                    完成
                  </Button>
                ) : (
                  ''
                )}
                <Button
                  style={{ display: type === '9' ? 'none' : 'flex' }}
                  ref={saveRef}
                  variant="contained"
                  className="coupons-setting-button"
                  type="submit"
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  完成
                </Button>
              </>
            )}
            <Button
              variant="contained"
              className="coupons-setting-button"
              color="secondary"
              onClick={handleExitClick}
              startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
            >
              退出
            </Button>
          </Box>
        </form>
      </Box>
      <Dialog
        open={openPriceDialog}
        onClose={() => {
          setOpenPriceDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            确定全部票档都适用免票券吗？请谨慎操作
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenPriceDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenPriceDialog(false);
              saveRef.current.click();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {opt !== OPT_DETAIL ? '退出后将不保存设置内容，确定要退出吗？' : ''}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={() => {
              setOpenDialog(false);
              history.goBack();
            }}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>

      <ModalML
        open={dialogStatus}
        setOpen={setDialogStatus}
        onCancel={handleCancel}
        title="选择票档"
        onConfirm={handleAddTicket}
        onClose={handleClose}
      >
        <CouponModal
          open={dialogStatus}
          control={control}
          setOpen={setDialogStatus}
          onConfirm={handleAddTicket}
          couponList={ticketList}
          setTicketList={setTicketList}
          showType={watch('isAllGoods')}
        ></CouponModal>
      </ModalML>
      <ModalML
        open={departmentDialogStatus}
        setOpen={setDepartmentDialogStatus}
        onCancel={handleDepartmentClose}
        title="选择部门"
        onConfirm={handleAddDepartment}
        onClose={handleDepartmentClose}
      >
        <DepartmentModal
          open={departmentDialogStatus}
          control={control}
          setOpen={setDepartmentDialogStatus}
          onConfirm={handleAddDepartment}
          chooseList={departmentList}
          setChooseList={setDepartmentList}
        ></DepartmentModal>
      </ModalML>
      <ModalML
        open={thirdDialogStatus}
        setOpen={setThirdDialogStatus}
        onCancel={handleCloseThirdCoupon}
        title="选择三方券"
        onConfirm={handleAddThirdCoupon}
        onClose={handleCloseThirdCoupon}
      >
        <ThirdCouponModal
          open={thirdDialogStatus}
          control={control}
          setOpen={setThirdDialogStatus}
          onConfirm={handleAddThirdCoupon}
          chooseList={thirdCouponList}
          setChooseList={setThirdCouponList}
        ></ThirdCouponModal>
      </ModalML>
      <ImagePreviewDialog onClose={handlePreviewClose} visible={previewOpen}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            alt=""
            src={previewUrl}
            style={{
              maxWidth: `${clientWidth * 0.6}px`,
              maxHeight: `${clientHeight * 0.6}px`,
              margin: 'auto',
            }}
          />
        </div>
      </ImagePreviewDialog>
    </Styled>
  );
};
